module.exports = __webpack_public_path__ + "img/About_ys_small_1.adb75031.png";